<template>
    <div id="main">
        <loader v-if="isLoading" />
        <!-- CONTAINER DE ALERTAS -->
        <alert-container :messages="msgs" />

        <div class="listing-header">
            <div class="title-breadcrumb">
                <h1 class="title">
                    {{ $t('vincular-fornecedor') }}
                </h1>
            </div>
            <div class="header-buttons">
                <button
                    class="delete-btn"
                    type="button"
                    @click="onFecharModal"
                >
                    {{ $t("cancelar") }}
                </button> 
                <button
                    class="save-btn"
                    type="button"
                    @click="save"
                    :disabled="FornecedorRestricaoSelecionados.length === 0"
                >
                    {{ $t("salvar") }}
                </button>
            </div>
        </div>

        <div class="search-and-filter">
            <div class="search-bar">
                <search-bar
                    :onSearch="debouncedOnSearch"
                    tooltipLabel="msg-campo-busca-fornecedor-restricao"
                />
            </div>
        </div>

        <div class="registry-wrapper">
            <empty-table-message v-if="isEmpty" />
            <b-table
                v-else
                :data="fornecedorrestricao"
                class="data-table"
                @sort="sortTable"
                backend-sorting
                checkable
                :checked-rows.sync="FornecedorRestricaoSelecionados" 
                :custom-is-checked="(selecionados, linha) => selecionados.idfornecedor === linha.idfornecedor"
            >
                <b-table-column
                    v-for="(f, i) in fields"
                    :key="i"
                    :field="f.key"
                    :label="$t(f.key)"
                    :width="f.width"
                    :sortable="f.sortable"
                    :custom-sort="f.sortFn"    
                    v-slot="props"
                >
                    <div>
                        {{ props.row[f.key] }}
                    </div>   
                </b-table-column>
            </b-table>

            <PaginationViewer
                class="mb-0"
                :resetPagination="pagination.resetPagination"
                :totalItems="pagination.totalRows"
                :perPageOptions="pagination.perPageOptions"
                :optionStarted="pagination.optionStarted"
                @change="updatePagination"
            />
        </div>
    </div>
</template>

<script>
import AssFornecedorRestricaoCliente from '@/services/vendas/cliente/abas/AssFornecedorRestricaoClienteService';

export default {
    props: {
        idcliente: 0,
    },
    data() {
        return {

            service: new AssFornecedorRestricaoCliente(this.$http, this.$router),
            fornecedorrestricao: [],
            isLoading: false,
            isEmpty: false,
            fields: [
                { key: 'codigo', width: null, sortable: true, sortFn: null },
                { key: 'nome', width: null, sortable: true, sortFn: null },
                { key: 'rsocial', width: null, sortable: true, sortFn: null },
            ],
            FornecedorRestricaoSelecionados: [],
            idfornecedor: 0,
            debouncedOnSearch: null,
            queryFilter: '',
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            column: 'nome',
            order: 'asc',
            msgs: [],

            isVenda: this.$route.meta.contexto == "vendas",
        }
    },
    created() {
        this.pagination.perPage = this.pagination.perPageOptions[
            this.pagination.optionStarted
        ];
        this.carregarDados();
        this.debouncedOnSearch = this.debounce(this.onSearch, 500);
    },
    methods: {
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1){
                this.pagination.resetPagination = true;
            }

            this.isLoading = true;

            this.findNaoAssociados(
                this.column,
                this.order,
                currentPage - 1,
                this.pagination.perPage,
                this.idcliente,
                this.queryFilter
            )
            .then(this.mapItems)
            .then(value => {
                this.fornecedorrestricao = value;
                this.isEmpty = this.fornecedorrestricao.length === 0;
            })
            .catch(e => {
                this.isEmpty = true;
                this.$root.showMessage('error', 'msg-erro-load');
                console.error('Erro ao carregar os dados.');
            })
            .finally(_ => {
                this.isLoading = false;
                this.pagination.resetPagination = false;
            });
        },
        findNaoAssociados(column, order, page, limit, idcliente, ...params) {
            if(this.isVenda) {
                return this.service
                .findNaoAssociadosVendas(column, order, page, limit, idcliente, ...params);
            }else {
                return this.service
                .findNaoAssociadosAgro(column, order, page, limit, idcliente, ...params);
            }
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;
            return body.content.map(m => {
                return {
                    codigo: m.idfornecedorerp,
                    idcliente: this.idcliente,
                    idfornecedor: m.idfornecedor,
                    nome: m.nome,
                    rsocial: m.rsocial,               
                };
            });
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            this.carregarDados(this.pagination.currentPage);
        },
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value);
            this.pagination.currentPage = 1;
            this.carregarDados();
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        select(selected) {
            this.$emit('selected', selected);
        },
        save() {
            if (this.FornecedorRestricaoSelecionados.length > 0) {
                this.isLoading = true;

                this.saveFR()
                .then(value => {
                    if (value.content === null) {
                        this.msgs.push(new Message("error", `${value.message}`, true));
                    } else {
                        this.$emit('fecharModal', true);   
                        this.$root.showMessage('success', 'msg-sucesso-ao-adicionar-associacao');
                    }
                })
                .catch((e) => {
                    this.msgs.push(new Message("alert", 'msg-erro-load', true));
                })
                .finally(() => {
                    this.isLoading = false;
                });
            } else {
                this.msgs.push(new Message("error", 'msg-selecione-forma-recebimento', true));
                this.isLoading = false;
                }
        },
        saveFR() {
            if(this.isVenda) return this.service.saveVendas(this.FornecedorRestricaoSelecionados);
            else return this.service.saveAgro(this.FornecedorRestricaoSelecionados);
        },
        onFecharModal(){
            this.$emit('fecharModal',true);
        }
    },
}
</script>


<style lang="scss" scoped>
#main {
    padding: 20px 20px;

    .search-and-filter {
        .search-bar {
            width: 100%;
        }
        @media (max-width: 760px) {
            .search-bar {
                padding-right: 0;
            }
        }
    }
}
</style>
